<template>
  <div id="con">
    <div class="con" v-bind:style="{ backgroundImage: 'url(' + path + ')' }">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<style scoped>
#con {
  width: 270px;
  margin-bottom: 32px;
}

.con > p {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #8f8f8f;
  padding: 16px 0;
}
.con {
  background-color: #ffffff;
  border-radius: 4px;
  width: 264px;
  height: 427px;
  user-select: none;
  overflow: hidden;
  border: 4px solid #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 60px rgba(0, 0, 0, 0.1) inset;
  background-image: url("/src/assets/logo.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
</style>

<script>
export default {
  data() {
    return {
      imgpath: require("@/assets/patent/1.jpg")
    };
  },
  props: ["path", "title"]
};
</script>
